export const red_100 = '#FCD4D4';
export const red_200 = '#FCC0C0';
export const red_300 = '#FB9797';
export const red_400 = '#F26969';
export const red_500 = '#EF4343';
export const red_550 = '#D10000';
export const red_600 = '#A30000';
export const red_700 = '#850000';
export const red_800 = '#6C0000';
export const red_900 = '#530000';
export const red_1000 = '#320000';
export const red = red_500;
export const orange_100 = '#FEE5C7';
export const orange_200 = '#FDCF9B';
export const orange_300 = '#FFA947';
export const orange_400 = '#F38C16';
export const orange_500 = '#CC7410';
export const orange_600 = '#9D5707';
export const orange_700 = '#764105';
export const orange_800 = '#532E03';
export const orange_900 = '#3B2102';
export const orange_1000 = '#271602';
export const orange = orange_400;
export const yellow_100 = '#FFF4C7';
export const yellow_200 = '#FFE57A';
export const yellow_300 = '#FAD957';
export const yellow_400 = '#EBBE0A';
export const yellow_500 = '#BA9608';
export const yellow_600 = '#846B06';
export const yellow_700 = '#624F04';
export const yellow_800 = '#453703';
export const yellow_900 = '#312802';
export const yellow_1000 = '#221C01';
export const yellow = yellow_400;
export const lime_100 = '#EEFEC2';
export const lime_200 = '#DEFA91';
export const lime_300 = '#C3F342';
export const lime_400 = '#A2D80E';
export const lime_500 = '#89B80A';
export const lime_600 = '#5B7906';
export const lime_700 = '#425705';
export const lime_800 = '#2F3F03';
export const lime_900 = '#212C02';
export const lime_1000 = '#161D02';
export const lime = lime_400;
export const green_100 = '#CFFCDB';
export const green_200 = '#ABF8BF';
export const green_300 = '#84EBA0';
export const green_400 = '#50D975';
export const green_500 = '#1AA33E';
export const green_600 = '#1A7F34';
export const green_700 = '#0C5A21';
export const green_800 = '#074016';
export const green_900 = '#052E10';
export const green_1000 = '#04200C';
export const green = green_500;
export const teal_100 = '#C5F9F2';
export const teal_200 = '#A6F2E8';
export const teal_300 = '#8AE2D6';
export const teal_400 = '#33CCB8';
export const teal_500 = '#29A393';
export const teal_600 = '#137669';
export const teal_700 = '#095349';
export const teal_800 = '#073C35';
export const teal_900 = '#052E28';
export const teal_1000 = '#04201C';
export const teal = teal_400;
export const cyan_100 = '#CCF1FF';
export const cyan_200 = '#AFE9FD';
export const cyan_300 = '#76D6F9';
export const cyan_400 = '#3EBEED';
export const cyan_500 = '#289EC9';
export const cyan_600 = '#0A749B';
export const cyan_700 = '#044E69';
export const cyan_800 = '#03374A';
export const cyan_900 = '#022B3B';
export const cyan_1000 = '#021D27';
export const cyan = cyan_300;
export const sky_100 = '#D3E5FD';
export const sky_200 = '#BAD7FD';
export const sky_300 = '#8EBDFB';
export const sky_400 = '#5FA1F7';
export const sky_500 = '#4290F5';
export const sky_600 = '#1C65C4';
export const sky_700 = '#0E438A';
export const sky_800 = '#063066';
export const sky_900 = '#05244D';
export const sky_1000 = '#031833';
export const sky = sky_500;
export const indigo_100 = '#D8DDFD';
export const indigo_200 = '#CAD0FC';
export const indigo_300 = '#A0ACF8';
export const indigo_400 = '#7F8EF5';
export const indigo_500 = '#6073EB';
export const indigo_600 = '#3F52D5';
export const indigo_700 = '#253498';
export const indigo_800 = '#132176';
export const indigo_900 = '#0C165A';
export const indigo_1000 = '#070E40';
export const indigo = indigo_600;
export const purple_100 = '#E7D8FD';
export const purple_200 = '#D9C1FA';
export const purple_300 = '#BF98F6';
export const purple_400 = '#A97AEB';
export const purple_500 = '#9460DC';
export const purple_600 = '#763CC8';
export const purple_700 = '#521F99';
export const purple_800 = '#3A1173';
export const purple_900 = '#2B0A57';
export const purple_1000 = '#1E0642';
export const purple = purple_500;
export const pink_100 = '#FDD1F1';
export const pink_200 = '#FBB6E9';
export const pink_300 = '#F58AD8';
export const pink_400 = '#EA66C7';
export const pink_500 = '#E250BB';
export const pink_600 = '#B82E93';
export const pink_700 = '#7C1861';
export const pink_800 = '#5B0B46';
export const pink_900 = '#410631';
export const pink_1000 = '#2F0423';
export const pink = pink_500;
export const magenta_100 = '#FDD1E5';
export const magenta_200 = '#FBBBD8';
export const magenta_300 = '#F792C0';
export const magenta_400 = '#ED6EA7';
export const magenta_500 = '#DF498D';
export const magenta_600 = '#BC246A';
export const magenta_700 = '#811345';
export const magenta_800 = '#5C0A2F';
export const magenta_900 = '#450823';
export const magenta_1000 = '#2F0417';
export const magenta = magenta_600;
export const blue_100 = '#EFF8FF';
export const blue_150 = '#DFF0FD';
export const blue_200 = '#CFE8FC';
export const blue_300 = '#85C8FF';
export const blue_400 = '#38A5FF';
export const blue_500 = '#128DF2';
export const blue_600 = '#006FCC';
export const blue_700 = '#004C9D';
export const blue_800 = '#003474';
export const blue_900 = '#00265B';
export const blue_1000 = '#001533';
export const blue = blue_400;
/** @deprecated use `blue` instead */
export const steel_blue_100 = '#F0F4F7';
/** @deprecated use `blue` instead */
export const steel_blue_200 = '#DFE5EB';
/** @deprecated use `blue` instead */
export const steel_blue_300 = '#B8C1CC';
/** @deprecated use `blue` instead */
export const steel_blue_400 = '#9AA5B2';
/** @deprecated use `blue` instead */
export const steel_blue_500 = '#768494';
/** @deprecated use `blue` instead */
export const steel_blue_600 = '#5D6A7A';
/** @deprecated use `blue` instead */
export const steel_blue_700 = '#475566';
/** @deprecated use `blue` instead */
export const steel_blue_800 = '#354252';
/** @deprecated use `blue` instead */
export const steel_blue_900 = '#19222E';
/** @deprecated use `blue` instead */
export const steel_blue_950 = '#10171F';
/** @deprecated use `blue` instead */
export const steel_blue_1000 = '#0B1117';
/** @deprecated use `blue` instead */
export const steel_blue = steel_blue_400;
export const steel_gray_50 = '#F8FAFB';
export const steel_gray_100 = '#F0F4F7';
export const steel_gray_150 = '#E9EEF2';
export const steel_gray_200 = '#E4E8EB';
export const steel_gray_300 = '#C5CCD1';
export const steel_gray_400 = '#A6ADB2';
export const steel_gray_500 = '#858E94';
export const steel_gray_600 = '#656F76';
export const steel_gray_700 = '#525D66';
export const steel_gray_800 = '#404A52';
export const steel_gray_850 = '#303940';
export const steel_gray_900 = '#1F272E';
export const steel_gray_950 = '#141A1F';
export const steel_gray_1000 = '#0E1317';
export const steel_gray_1050 = '#181F25';
export const steel_gray_1100 = '#141A1F';
export const steel_gray_1150 = '#0B0F12';
export const steel_gray = steel_gray_400;
export const gray_50 = '#F9F9F9';
export const gray_100 = '#F4F5F5';
export const gray_200 = '#EAEBEB';
export const gray_300 = '#DADBDB';
export const gray_400 = '#B8B8B8';
export const gray_500 = '#929191';
export const gray_600 = '#707070';
export const gray_700 = '#575757';
export const gray_800 = '#484848';
export const gray_900 = '#333333';
export const gray_950 = '#242424';
export const gray_1000 = '#1A1A1A';
export const gray_1025 = '#141414';
export const gray_1050 = '#0D0D0D';
export const gray = gray_400;
export const black = '#000000';
export const white = '#FFFFFF';
export const transparent = 'transparent';
//# sourceMappingURL=color.js.map